module.exports = require("babel-register");


//////////////////
// WEBPACK FOOTER
// external "babel-register"
// module id = 116
// module chunks = 0 1